import { CreateOrderRequest } from '@models/order';
import dayjs from 'dayjs';
import { openDB } from 'idb';

const DB_NAME = 'order';
const STORE_NAME_ORDER = 'tempOrder';
const STORE_NAME_EASY_CARD = 'tempOrderEasyCard';
const DB_VERSION = 2;
const ID_KEY = 'id';
const ID_VALUE = 'app';
const TEMP_ORDER_MINUTE = 10;

export type TempOrderType = 'ORDER' | 'EASY_CARD';

async function getDB() {
    return openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME_ORDER)) {
                db.createObjectStore(STORE_NAME_ORDER, { keyPath: ID_KEY });
            }
            if (!db.objectStoreNames.contains(STORE_NAME_EASY_CARD)) {
                db.createObjectStore(STORE_NAME_EASY_CARD, { keyPath: ID_KEY });
            }
        },
    });
}

function getStoreName(type: TempOrderType) {
    return type === 'ORDER' ? STORE_NAME_ORDER : STORE_NAME_EASY_CARD;
}

export async function saveTempOrder(request: CreateOrderRequest, type: TempOrderType) {
    const db = await getDB();
    const storeName = getStoreName(type);
    await db.put(storeName, {
        ...request,
        id: ID_VALUE,
        expiresAt: dayjs().add(TEMP_ORDER_MINUTE, 'minute').toString(),
    });
}

export async function getTempOrder(type: TempOrderType): Promise<CreateOrderRequest|undefined> {
    const db = await getDB();
    try {
        const storeName = getStoreName(type);
        const row = await db.get(storeName, ID_VALUE);
        console.log({ row });
        await deleteTempOrder(type);
        if (typeof row === 'object') {
            if ('expiresAt' in row && dayjs().isAfter(dayjs(row.expiresAt))) {
                return undefined;
            }
            return row as CreateOrderRequest;
        }
        return undefined;
    } catch {
        return undefined;
    }
}

async function deleteTempOrder(type: TempOrderType) {
    const db = await getDB();
    const storeName = getStoreName(type);
    await db.delete(storeName, ID_VALUE);
}
